import originAxios from "axios";

const HOST_SERVER = process.env.REACT_APP_MAIN_DOMAIN ? `https://auditor.${process.env.REACT_APP_MAIN_DOMAIN}` : 'http://localhost:3000';
const AUTH_TOKEN = "AUTH_TOKEN";
const REFRESH_TOKEN = "refresh-token";
const ACCESS_TOKEN = "access-token";

const HEADERS = {
  "Accept": "application/json",
  "Content-Type": "application/json"
}

function errorhandler(errorRes) {
  const { response } = errorRes;
  if (response) {
    throw { status: errorRes.response.status, data: errorRes.response.data };
  } else {
    throw { data: { message: "error", success: false, error: errorRes } };
  }
}

const axiosInst = originAxios.create({
  baseURL: HOST_SERVER,
});
class MyAxios {
  getImageFile(path) {
    const token = localStorage.getItem(AUTH_TOKEN)
    return `${HOST_SERVER}${path}?token=${token}`
  }
  getFullPath(path) {
    return `${HOST_SERVER}${path}`
  }
  getHeaders(additional = {}) {
    let newheaders = {},
      authToken = localStorage.getItem('NM-API-Key');
    if (authToken) {
      newheaders['NM-API-Key'] = authToken
    }
    return { headers: { ...HEADERS, ...newheaders, ...additional } }

  }
  async responseHandler(response) {
    if (response.headers && response.headers[ACCESS_TOKEN]) {
      localStorage.setItem(AUTH_TOKEN, response.headers[ACCESS_TOKEN])
    }
    return response.data
  }
  get(path, newheaders) {
    return axiosInst.get(path, this.getHeaders(newheaders))
      .then(this.responseHandler)
      .catch(errorhandler);
  }
  post(path, body, newheaders) {
    return axiosInst.post((HOST_SERVER + path), body, this.getHeaders(newheaders))
      .then(this.responseHandler)
      .catch(errorhandler)
  }
  delete(path, newheaders) {
    return axiosInst.delete((HOST_SERVER + path), this.getHeaders(newheaders))
      .then(this.responseHandler)
      .catch(errorhandler)
  }
  put(path, body, newheaders) {
    return axiosInst.put((HOST_SERVER + path), body, this.getHeaders(newheaders))
      .then(this.responseHandler)
      .catch(errorhandler)
  }
  patch(path, body, newheaders) {
    return new Promise((resolve, reject) => {
      this.getHeaders(newheaders)
        .then(headers => {
          if (body instanceof FormData) {
            headers['Content-Type'] = 'multipart/form-data'
          }
          return axiosInst.patch(HOST_SERVER + path, body, headers)
        })
        .then(res => {
          return this.responseHandler(res)
        }).then(resolve).catch(reject)
    }).catch(errorhandler)
  }
}


export const axios = new MyAxios();